import { contactClientsEndpoint as endpoint } from '../constants/endpointsContants';
import request from './genericRequestService';

async function fetchContactClient() {
    return await request.get({ endpoint });
}

export { fetchContactClient };
